<div class="row">
  <div class="col p-0 mr-8px">
    <input type="tel" [mask]="mask" placeholder="000000" name="verify-input-name-1" class="soma-filed center verify-field"
      id="verify-input" required (input)="checkForm()" [(ngModel)]="verifyInput">
  </div>
</div>